import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import CustomServices from "./CustomServices";
import Copyright from '../../common/footer/Copyright';
import FooterTwo from '../../common/footer/FooterTwo';

const Services = () => {
    return (
        <>

            <SEO
                title="Service || Doob - React Business  Template"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "serviceType": "Digital Marketing and Web Development Services",
                    "provider": {
                        "@type": "ProfessionalService",
                        "name": "WhatsOn Digital Agency",
                        "url": "https://whatson.agency/",
                        "logo": "https://whatson.agency/images/logo/WhatsOnAgencyWhite.png",
                        "sameAs": [
                            "https://www.facebook.com/whatsondigitalagency"
                        ],
                        "telephone": "+44 121 655 1122",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "13a Cannon St",
                            "addressLocality": "Birmingham",
                            "postalCode": "B2 5EN",
                            "addressCountry": "UK"
                        }
                    },
                    "areaServed": {
                        "@type": "Place",
                        "name": "International"
                    },
                    "description": "WhatsOn Digital Agency provides Development Web Design and Development, Web Application, eCommerce Solution, ERP Solutions, CRM Solutions, Email Marketing, Video Editing, Domain Register, Web Hosting, SEO, Facebook Ads, YouTube Advertisement, Google Advertisement and online growth solutions for businesses.",
                    "url": "https://whatson.agency/services"
                }}
            />
            <Layout>
                {/* <BreadcrumbOne 
                    title="The Easiest Way To Create Website <br /> Quick Copy & Make site."
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Service"
                /> */}
                <div className="main-content">

                    {/* Start Service Area  */}
                    <section className="rn-service-area rn-section-gap" role="region" aria-label="Services section">
                        <div className="container">
                            {/* <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "What we can do for you"
                                        title = "Services provide for you."
                                        description = "There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration."
                                     />
                                </div>
                            </div> */}
                            <CustomServices 
                                serviceStyle = "service__style--1 bg-color-blackest radius mt--25"
                                textAlign = "text-center"
                            />
                           
        
                        </div>
                    </section>

                   


                    

                </div>

            </Layout>
            <FooterTwo />
            <Copyright/>
            
        </>
    )
}

export default Services;
